const TYPE = 'SET_CONFIG_PARAM';

const action = (parameter) => (dispatch) => dispatch({ type: TYPE, payload: parameter });

export default { action, TYPE };
